import { theme } from 'styles/theme/hav-theme'

export const officeColors = {
  TODOS: theme.colors.primary.main,
  AC60: '#EA387F', // TODO: Check with design
  AESP: '#DF5D00', // TODO: Check with design
  ASMD: theme.colors.primary.main
}
